/* !!!!!!!!!!!!!!!!!!!!!! */
/* !!! GENERATED FILE !!! */
/* !!!!!!!!!!!!!!!!!!!!!! */

import {
  ModuleDoneType,
  ModuleType,
  PlaniraPlanImage,
  type PlaniraTemplate,
} from "../../types";
import { PlanType } from "../../types";
import { PlanTemplateType } from "../template_types";

export const FlowNatureExplorationTemplate: PlaniraTemplate = {
  type: PlanTemplateType.FlowNatureExploration,

  planType: PlanType.Quickstart,
  suggestedTitles: [
    "Let’s Explore Nature Together!",
    "Nature Exploration Awaits!",
    "Discover the Great Outdoors!",
  ],
  title: "Nature Exploration",
  description: "Organize a fun nature exploration day.",
  longDescription:
    "Gather your friends for an exciting nature exploration! Choose a date, decide on trails to hike, and plan activities!",
  emoji: "🌳",
  titleHelp: "Change title or choose another:",
  imageType: PlaniraPlanImage.Travel,

  sections: [
    {
      section: {
        isExpandable: false,
        isDraggable: false,
      },
      modules: [
        {
          type: ModuleType.PlanInfo,
          doneType: ModuleDoneType.None,
          title: "Nature Exploration",
          emoji: "🌳",
        },
      ],
    },
    {
      section: {
        title: "Ongoing",
      },
      modules: [
        {
          type: ModuleType.Calendar,
          doneType: ModuleDoneType.Voting,
          title: "When should we go for our nature exploration?",
          emoji: "📅",
          completeAction: {
            question: "Decide on trails to explore?",
            description: "What trails should we include in our exploration?",
            addModules: [
              {
                type: ModuleType.Poll,
                doneType: ModuleDoneType.Voting,
                title: "What trails should we consider?",
                emoji: "🥾",
                completeAction: {
                  question: "Decide on additional activities?",
                  description:
                    "What additional activities should we plan for the day?",
                  addModules: [
                    {
                      type: ModuleType.Poll,
                      doneType: ModuleDoneType.Voting,
                      title: "What activities should we bring?",
                      emoji: "🎣",
                    },
                  ],
                },
              },
            ],
          },
        },
      ],
    },
  ],

  onTemplateComplete: {
    outroTitle: "Let’s Enjoy Nature!",
    outroDescription:
      "Your nature exploration plans are set! Enjoy the adventure!",
  },
};
